import { Component, Inject, Input } from '@angular/core';

import { VBRICK_PLAYER_HOST } from '../../VbPlayerHostToken';

@Component({
	selector: 'vg-toggle-chapter-display-button',
	template: `
		<button
			type="button"
			[attr.aria-label]="vbrickPlayer.chapterHelper.showChapterImage ? translations.chapterImageShow : translations.chapterImageHide"
			[ngClass]="[
				'button',
				'vb-icon',
				vbrickPlayer.chapterHelper.showChapterImage ? 'vb-icon-image' : 'vb-icon-image-none'
			]"
			[tooltip]="chapterToggleTooltip"
			[placement]="'top'"
			(click)="toggleChapterImage()">
		</button>
		<ng-template #chapterToggleTooltip>
			{{ vbrickPlayer.chapterHelper.showChapterImage ? translations.chapterImageShow : translations.chapterImageHide }}
		</ng-template>
	`,
	standalone: false,
	styleUrls: ['./VgToggleChapterDisplayButton.Component.ng.less']
})
export class VgToggleChapterDisplayButtonComponent {
	@Input() public translations: any;

	constructor(
		@Inject(VBRICK_PLAYER_HOST)
		public vbrickPlayer: any
	) { }

	public toggleChapterImage(): void {
		this.vbrickPlayer.chapterHelper.setShowChapterImage(!this.vbrickPlayer.chapterHelper.showChapterImage);
	}

}


